"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanTags = cleanTags;
/*! Copyright (c) 2019, XAPPmedia */
/**
 * Clean HTML and XML tags from a string
 *
 * @param {string} str
 * @returns {string}
 */
function cleanTags(str) {
    if (!str) {
        return str;
    }
    const regex = /(<([^>]+?)>)/gi;
    return str.replace(regex, "");
}
//# sourceMappingURL=cleanTags.js.map